/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var config = require('../config'),
    tizen  = require('./tizen');


module.exports = function () {
    var result;

    if ( PLATFORM === 'TIZEN' ) {
        result = {
            items: [
                {className: 'theme-icon theme-icon-monitor'},
                {
                    value: gettext('About device'),
                    data: [
                        {type: 'title', data: gettext('User MAC')},
                        {type: 'text', data: tizen.getDeviceMac()},
                        {type: 'title', data: gettext('Tizen version')},
                        {type: 'text', data: tizen.getTizenVersion()},
                        {type: 'title', data: gettext('TV model')},
                        {type: 'text', data: tizen.getTvVersion()}
                    ]
                }
            ]
        };
    } else {
        result = {
            items: [
                {className: 'theme-icon theme-icon-monitor'},
                {
                    value: gettext('About device'),
                    data: [
                        {type: 'title', data: gettext('User MAC')},
                        {type: 'text', data: config.user.mac}
                    ]
                }
            ]
        };
    }

    return result;
};
